var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scale-wrapper"},[_c('div',[_c('item-scale',{attrs:{"availableValues":_vm.availableValues,"anchors":_vm.anchors,"readOnly":_vm.readOnly,"printView":_vm.printView,"label":_vm.label,"small":_vm.small},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }